import { NAV_PREFIXES, NAV_RUBRIQUES, type NavRubriqueKey } from "../helpers/navCatalog.generated";

/** Miroir de NavCatalog::normalizePath : query et fragment retirés, slash final ajouté. */
export function normalizeNavPath(path: string): string | null {
  const bare = path.replace(/[?#].*$/s, "");
  if (!bare.startsWith("/") || bare.startsWith("//")) return null;
  return bare.endsWith("/") ? bare : `${bare}/`;
}

/** Miroir de NavCatalog::rubriqueForPath. */
export function rubriqueForPath(path: string): NavRubriqueKey | null {
  const normalized = normalizeNavPath(path);
  if (normalized === null) return null;
  for (const rubrique of NAV_RUBRIQUES) {
    if (rubrique.items.some((item) => item.path === normalized)) return rubrique.key;
  }
  for (const [prefix, key] of Object.entries(NAV_PREFIXES)) {
    if (normalized.startsWith(prefix) && normalized !== prefix) return key;
  }
  return null;
}

/** Miroir de Breadcrumb::trail. */
export function breadcrumbTrail(path: string, label: string): { name: string; path: string }[] {
  const trail = [{ name: "Accueil", path: "/" }];
  const normalized = normalizeNavPath(path);
  if (normalized === null || normalized === "/") return trail;
  const key = rubriqueForPath(normalized);
  if (key !== null) {
    const rubrique = NAV_RUBRIQUES.find((r) => r.key === key)!;
    trail.push({ name: rubrique.label, path: rubrique.hubPath });
    if (rubrique.hubPath === normalized) return trail;
  }
  trail.push({ name: label, path: normalized });
  return trail;
}
